var React = require('react');
var ReactDOM = require('react-dom');
var { createElement: h, useState } = React;
var { JsonTreeNode } = require('./JsonTreeViewer');

function NodeOutputPanel(props) {
  var output = props.output;
  var showFixButton = !!props.showFixButton;
  var onOpenEditModal = props.onOpenEditModal || null;
  var isFixing = !!props.isFixing;
  var onRerunFromNode = props.onRerunFromNode || null;
  // Existing variable names + the capture callback for the per-row "set to
  // variable" buttons. When absent (no callback), the buttons don't render.
  var variableNames = props.variableNames || [];
  var onSetToVariable = props.onSetToVariable || null;
  // While the user is wiring a connection, the bottom anchor sits right over
  // this panel — don't let a hover auto-expand it and disrupt the drag.
  var isConnectionDragging = !!props.isConnectionDragging;
  var [isPinned, setIsPinned] = useState(false);
  var [isHovered, setIsHovered] = useState(false);
  var [isForceClosed, setIsForceClosed] = useState(false);
  var [isFullscreen, setIsFullscreen] = useState(false);

  var isError = output && typeof output === 'object' && output.__error === true;

  var parsed = output;
  if (!isError) {
    if (typeof output === 'string') {
      var trimmed = output.trim();
      if (trimmed[0] === '{' || trimmed[0] === '[') {
        try { parsed = JSON.parse(trimmed); } catch(e) {}
      }
    }
  }

  var isComplex = !isError && parsed !== null && parsed !== undefined && typeof parsed === 'object';

  // Pinned panels stay open (explicit user intent); hover-open is ignored
  // mid-drag so wiring a connection never makes the panel balloon open.
  var isOpen = !isForceClosed && (isPinned || (isHovered && !isConnectionDragging));

  var panelClassName = 'node-output-panel' +
    (isError ? ' node-output-panel-error' : '') +
    (isOpen ? ' node-output-panel-open' : '') +
    (isForceClosed ? ' node-output-panel-closed' : '');

  function handleFixBtnMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    if (isFixing || !onOpenEditModal) return;
    onOpenEditModal(output);
  }

  return h('div', {
    className: panelClassName,
    onMouseDown: function(e) { e.stopPropagation(); },
    onMouseEnter: function() {
      if (isForceClosed) return;
      if (isConnectionDragging) return;
      setIsHovered(true);
    },
    onMouseLeave: function() {
      setIsHovered(false);
      setIsForceClosed(false);
    }
  },
    h('div', {
      className: 'node-output-header' + (isError ? ' node-output-header-error' : ''),
      onClick: function(e) {
        e.stopPropagation();
        setIsForceClosed(false);
        setIsPinned(function(v) { return !v; });
      }
    },
      h('span', { className: 'node-output-toggle' }, isOpen ? '\u25be' : '\u25b8'),
      h('span', { className: 'node-output-label' }, isError ? 'Error' : 'Output'),
      null,
      isOpen
        ? h('button', {
            className: 'node-output-fullscreen-btn',
            onMouseDown: function(e) {
              e.preventDefault();
              e.stopPropagation();
              setIsFullscreen(true);
            },
            title: 'Fullscreen output'
          },
            h('svg', { xmlns: 'http://www.w3.org/2000/svg', width: '10', height: '10', viewBox: '0 0 10 10', fill: 'none', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' },
              h('path', { d: 'M1 4V1h3M6 1h3v3M9 6v3H6M4 9H1V6' })
            )
          )
        : null,
      isOpen
        ? h('button', {
            className: 'node-output-close',
            onMouseDown: function(e) {
              e.preventDefault();
              e.stopPropagation();
              setIsPinned(false);
              setIsHovered(false);
              setIsForceClosed(true);
            },
            title: 'Close output'
          }, '\u00d7')
        : null
    ),
    isOpen
      ? h('div', { className: 'node-output-body' },
          isError
            ? h('div', { className: 'node-output-error' }, output.message || 'Unknown error')
            : isComplex
              ? h('div', { className: 'node-output-tree' },
                  h(JsonTreeNode, { label: null, value: parsed, depth: 0, path: '', variableNames: variableNames, onSetToVariable: onSetToVariable })
                )
              : h('div', { className: 'node-output-text' },
                  parsed === null ? 'null'
                    : parsed === undefined ? 'undefined'
                    : String(parsed)
                )
        )
      : null,
    isFullscreen
      ? ReactDOM.createPortal(
          h('div', {
            className: 'node-output-fullscreen-overlay',
            onMouseDown: function(e) { e.stopPropagation(); },
            onClick: function(e) { if (e.target === e.currentTarget) setIsFullscreen(false); }
          },
            h('div', { className: 'node-output-fullscreen-modal' },
              h('div', { className: 'node-output-fullscreen-header' },
                h('span', { className: 'node-output-fullscreen-title' }, '\u29f8\u29f9 OUTPUT'),
                h('button', {
                  className: 'node-output-fullscreen-close',
                  onClick: function(e) { e.stopPropagation(); setIsFullscreen(false); }
                }, '\u00d7')
              ),
              h('div', { className: 'node-output-fullscreen-body' },
                isError
                  ? h('div', { className: 'node-output-error' }, output.message || 'Unknown error')
                  : isComplex
                    ? h('div', { className: 'node-output-tree' },
                        h(JsonTreeNode, { label: null, value: parsed, depth: 0, path: '', variableNames: variableNames, onSetToVariable: onSetToVariable })
                      )
                    : h('div', { className: 'node-output-text' },
                        parsed === null ? 'null'
                          : parsed === undefined ? 'undefined'
                          : String(parsed)
                      )
              )
            )
          ),
          document.body
        )
      : null
  );
}

module.exports = NodeOutputPanel;
